import {Mapper} from '@s-ui/domain'

export class FromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper extends Mapper {
  constructor({config, searchRequestValueObjectFactory}) {
    super()
    this._config = config
    this._searchRequestValueObjectFactory = searchRequestValueObjectFactory
    this._sortFields = this._config.get('SORT_FIELDS')
    this._sortQueryParams = this._config.get('SORT_QUERY_PARAM')
    this._adsListSize = this._config.get('search').ADS_LIST_SIZE
    this._offerTypeSubscription = this._config.get('search').OFFER_TYPE_SUBSCRIPTION
    this._sortFields = this._config.get('SORT_FIELDS')
    this._sortOrderAsc = this._config.get('ORDER').ASC
    this._removeMake = false
  }

  setParams = ({removeMake = false}) => {
    this._removeMake = removeMake
    return this
  }

  map = searchRequestValueObject => {
    const {makeId, page, sortBy: filteredSortBy, sortOrder: filteredSortOrder} = searchRequestValueObject.toJSON()

    let sortBy = filteredSortBy
    if (makeId) {
      sortBy = this._sortFields.MONTHLY_SUBSCRIPTION_FEE
    }

    let sortOrder = filteredSortOrder
    if (makeId) {
      sortOrder = this._sortOrderAsc
    }

    return this._searchRequestValueObjectFactory({
      ...(!this._removeMake && {makeId}),
      offerTypeId: this._offerTypeSubscription,
      page,
      sortBy,
      sortOrder
    })
  }
}
